export default __webpack_public_path__ + "static/media/blue2.3fc4e539.jpg";